<template>
  <div v-loading="loading">
    <div v-if="zxid2 != ''" class="content">

      <el-button type="warning" plain @click="shengcehng">重新生成该报告</el-button>

      <div style="font-size: 15px;display: flex;justify-content:space-between;margin: 15px 0;">
        <span>报告编号: {{ zhengxv2.resp_order }}</span>
        <span> 报告生成时间: {{ zhengxv2.timestamp | formatDate }} </span>
      </div>


      <div class="diyihang">
        状态:<span class="lanse">{{ zhengxv2.resp_msg }}</span>
      </div>

      <div style="display: flex;">
        <div class="num">
          <div class="card" v-for="item in listdata">
            {{ item.value }}: <span>{{ zhengxv2.resp_data[item.name] }} </span>
          </div>
        </div>
      </div>



    </div>
    <div v-else class="bgelse">
      <div class="tishi">提示：请生成报告后再查看该报告！</div>
      <div class="baogao">征信报告没有生成</div>
      <div class="shhengcheng">
        <el-button type="warning" plain @click="shengcehng">生成该报告</el-button>
      </div>
    </div>
  </div>
</template>
  
<script>
import FengkongApi from "@/api/fengkong.js";
import Table from '../../product/product/part/spec/many/Table.vue';
export default {
  components: { Table },
  props: ["zxid2", "order_id", "list", "zxid"],
  data() {
    return {
      loading: false,
      zhengxv2: "",
      listdata: ""
    };
  },
  created() {
    let self = this;

    self.listdata = self.list;
    // console.log("list", self.listdata);
    
    var data = JSON.parse(self.zxid2)
    self.zhengxv2 = data;
    // console.log("zhengxv2", typeof (self.zhengxv2), self.zhengxv2);
  },

  methods: {
    shengcehng() {
      let self = this;
      self.loading = true;
      let Params = {
        user_id: self.zxid,
        order_id: self.order_id
      };
      FengkongApi.zhengxin(Params, true)
        .then(data => {
          console.log(data.data.result.resp_data);
          self.zxid2 = data.data.result;
          self.zhengxv2 = data.data.result;
          self.loading = false;
          self.$message({
            message: '加载完成',
            type: 'success'
          });
        })
        .catch(error => { });

    },
  },
  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
  },
};
</script>
  
<style>
.num {

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

}

.num .card {
  width: 33%;
  padding: 5px;
  border: 1px solid #EFEFEF;
  font-size: 15px;
}

.num .card span {
  font-weight: bold;
}

.content {
  width: 100%;
  padding: 25px 33px 46px;
  background-color: #f5f6f8;
}

.diyihang {
  text-align: center;
  margin: 20px;
  font-size: 20px;
  width: 100%;
}

.lanse {
  color: #1890ff;
}

.biaoge {
  border-collapse: collapse;
  width: 100%;
}

.biaoge1 {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;
}

</style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/detail1a.vue